<div class="spinner">
  <nz-spin nzSize="large"></nz-spin>
</div>
